/* Pack selector: drives Horizon's own quantity input rather than replacing the form,
   so add-to-cart, sticky ATC and variant changes keep working untouched. */
(function () {
  'use strict';

  function productForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function setQuantity(n) {
    var form = productForm();
    if (!form) return;
    var quantity = Number(n) || 1;
    var changed = false;

    form.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      if (input.value === String(quantity)) return;
      input.value = String(quantity);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      changed = true;
    });

    if (!changed) return;

    /* The sticky add-to-cart bar clicks the real button, so it already adds the
       right number of boxes. Its "(2)" label, though, only updates when it hears
       Horizon's own quantity event — a plain input event is not enough. Without
       this the bar reads "Add to cart" while the pack selector says 2 boxes.
       cartLine is left undefined on purpose: the bar ignores cart-line updates. */
    document.dispatchEvent(
      new CustomEvent('quantity-selector:update', {
        bubbles: true,
        detail: { quantity: quantity },
      })
    );
  }

  /* Two visible quantity controls is confusing, so the theme's own one is hidden —
     but only when we can identify its wrapper, never by guessing upward. */
  function hideNativeQuantity() {
    var form = productForm();
    if (!form) return;
    form.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      var host = input.closest('quantity-selector, .quantity-selector, quantity-input, .product-form__quantity');
      if (host) host.style.display = 'none';
    });
  }

  function init(root) {
    var opts = Array.prototype.slice.call(root.querySelectorAll('.lvh-qty__opt'));
    if (!opts.length) return;

    function select(opt) {
      opts.forEach(function (o) {
        var on = o === opt;
        o.classList.toggle('is-on', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      setQuantity(opt.dataset.qty);
    }

    opts.forEach(function (opt) {
      opt.addEventListener('click', function () { select(opt); });
      opt.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          select(opt);
        }
      });
    });

    var preset = opts.filter(function (o) { return o.classList.contains('is-on'); })[0] || opts[0];
    hideNativeQuantity();
    select(preset);

    /* Horizon re-renders the details column on a variant change, which resets the
       quantity input. Re-apply the chosen pack when that happens. */
    var form = productForm();
    if (form) {
      new MutationObserver(function () {
        hideNativeQuantity();
        var current = opts.filter(function (o) { return o.classList.contains('is-on'); })[0];
        if (current) setQuantity(current.dataset.qty);
      }).observe(form, { childList: true, subtree: true });
    }
  }

  function boot() {
    document.querySelectorAll('.lvh-qty').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
